
import timeutils from 'utils/wt-time-utils'
import { newsStates, classifySortords } from 'json/information-options'
import { getEnumeration } from 'enumeration'
export default {
  getNewsList (data) {
    data.forEach((item, index) => {
      item.index = index + 1
      item.publish_date = timeutils.format(item.publishDate, 'date')
      item.news_state = getEnumeration(item.state, newsStates)
    })
    return data
  },
  newsDetail (data) {
    data.publish_date = timeutils.format(data.publishDate, 'date')
    return data
  },
  categoriesWithNewsCount (data) {
    data.forEach(item => {
      let extensionInfo = item.extensionInfo || {}
      item.created_date = item.createdDate && timeutils.format(item.createdDate, 'date')
      item.sort = extensionInfo.sort && getEnumeration(extensionInfo.sort, classifySortords)
    })
    return data
  },
  getNoticeList (data) {
    data.forEach(item => {
      item.send_to = item.sendTo && item.sendTo.length > 0 ? '指定用户' : '全部用户'
    })
    return data
  },
  noticeDetail (data) {
    data.send_to = data.sendTo ? '指定用户' : '全部用户'
    data.created_date = data.createdDate && timeutils.format(data.createdDate)
    return data
  }
}
